import { render } from "./ConsentOptions.vue?vue&type=template&id=4621f3e8&scoped=true"
import script from "./ConsentOptions.vue?vue&type=script&lang=js"
export * from "./ConsentOptions.vue?vue&type=script&lang=js"

import "./ConsentOptions.vue?vue&type=style&index=0&id=4621f3e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4621f3e8"]])

export default __exports__